import {PROJECT_COLLECTION} from '../../projects/domain/config';
import {getProjectMilestoneList} from '../reducers/state';
import {makeMilestoneList} from './configMilestonesList';
import {PROJECT_MILESTONE_LIST_PREFIX} from './state';


export const {
  componentOptions,
  /** @type {ReduxList} */
  reduxList,
} = makeMilestoneList({
  prefix: PROJECT_MILESTONE_LIST_PREFIX,
  getState: getProjectMilestoneList,
  parentPath: PROJECT_COLLECTION,
  childPath: 'project-milestones',
});



// WEBPACK FOOTER //
// ./src/js/milestones/redux/projectMilestoneList.js